export default __webpack_public_path__ + "static/media/checkSolid.5a740318.svg";